import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { requiredJobFields } from '../../../utils/constants';

class UploadPreview extends Component {
  render() {
    const missingColumnKeys = (r) => {
      const result = [];
      requiredJobFields.forEach((field) => {
        if (!r[field]) { result.push(field); }
        if (field === 'date' && r[field] === 'Invalid Date') { result.push('date (use YYYY/MM/DD)'); }
        if (field === 'url' && r[field] === 'Invalid URL') { result.push('url (include http://)'); }
      });
      return result;
    };
    const { data } = this.props;

    return (
      <BootstrapTable
        ref='JobUploadPreview'
        data={data || []}
        className='table'
        remote
      >
        <TableHeaderColumn
        width="50"
        dataField='job_number'
        isKey
        dataFormat={(c) => c}
        >
          Job #
        </TableHeaderColumn>
        <TableHeaderColumn
        width="200"
        dataField='referencenumber'
        dataFormat={(c) => c}
        >
          Reference Number
        </TableHeaderColumn>
        <TableHeaderColumn
        width="300"
        dataField="missing"
        dataFormat={(c, r) => missingColumnKeys(r)}
        >
          Missing/Invalid Fields
        </TableHeaderColumn>
      </BootstrapTable>
    );
  }
}

export default UploadPreview;
